import React from 'react';
import { UserGroupIcon, BanknotesIcon, ShoppingCartIcon, CreditCardIcon } from '@heroicons/react/24/outline';

export default function FinanceDashboard({ setFinanceView }) {
    return (
        <div>
            <div className="text-center mb-12">
                <h2 className="text-3xl font-bold text-[#213368]">Finance Center</h2>
                <p className="mt-2 text-lg text-gray-600">Select a service to manage vendors, purchases, or payments.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
                <button
                    onClick={() => setFinanceView('vendors')}
                    className="group flex flex-col items-center justify-center p-8 bg-white rounded-xl shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-gray-200"
                >
                    <UserGroupIcon className="h-10 w-10 mb-3 text-[#F4A866]" />
                    <h3 className="text-xl font-semibold text-[#213368] group-hover:text-[#20BEC6]">Vendor Management</h3>
                    <p className="mt-2 text-sm text-gray-500 text-center">Onboard new suppliers and manage vendor contracts and details.</p>
                </button>
                
                {/* --- NEW: Purchase Center Button --- */}
                <button
                    onClick={() => setFinanceView('purchases')}
                    className="group flex flex-col items-center justify-center p-8 bg-white rounded-xl shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-gray-200"
                >
                    <ShoppingCartIcon className="h-10 w-10 mb-3 text-[#F4A866]" />
                    <h3 className="text-xl font-semibold text-[#213368] group-hover:text-[#20BEC6]">Purchase Center</h3>
                    <p className="mt-2 text-sm text-gray-500 text-center">View and track all approved purchase orders across the company.</p>
                </button>

                <button
                    onClick={() => setFinanceView('payments')}
                    className="group flex flex-col items-center justify-center p-8 bg-white rounded-xl shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-gray-200"
                >
                    <BanknotesIcon className="h-10 w-10 mb-3 text-[#F4A866]" />
                    <h3 className="text-xl font-semibold text-[#213368] group-hover:text-[#20BEC6]">Payment Center</h3>
                    <p className="mt-2 text-sm text-gray-500 text-center">Process approved invoices and track payment history.</p>
                </button>
{/* --- NEW: Expense Reimbursement Center Button --- */}
                <button
                    onClick={() => setFinanceView('expenses')}
                    className="group flex flex-col items-center justify-center p-8 bg-white rounded-xl shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-gray-200"
                >
                    <CreditCardIcon className="h-10 w-10 mb-3 text-[#F4A866]" />
                    <h3 className="text-xl font-semibold text-[#213368] group-hover:text-[#20BEC6]">Expense Center</h3>
                    <p className="mt-2 text-sm text-gray-500 text-center">Review approved expense reports and process reimbursements.</p>
                </button>
            </div>
        </div>
    );
}